var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseBigV2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#5472CC",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24.293 7.293c.39.39.417.997.059 1.355l-14.26 14.26c-.358.358-.965.332-1.355-.059-.39-.39-.417-.997-.06-1.355l14.26-14.26c.359-.358.965-.332 1.356.059"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.293 7.707c.39-.39.997-.417 1.355-.059l14.26 14.26c.358.358.332.965-.059 1.355-.39.391-.997.417-1.355.06L8.234 9.062c-.358-.359-.332-.965.059-1.356"
})));
export default SvgCloseBigV2;